import { useApolloClient } from '@apollo/client';

import { CAR_SPECS_FIND_TRIM, CAR_SPECS_FIND_TRIM_SPECS } from './useCarSpecs.graphql';

export const useCarSpecs = () => {
  const client = useApolloClient();

  const getTrims = async (year: number, make: string, model: string): Promise<any[]> => {
    try {
      const { data } = await client.query({
        query: CAR_SPECS_FIND_TRIM,
        variables: {
          filters: [
            {
              field: 'year',
              intVal: year,
            },
            {
              field: 'make',
              strVal: make,
            },
            {
              field: 'model',
              strVal: model,
            },
          ],
        },
      });
      return data?.carSpecsFind || [];
    } catch (error: any) {
      console.log('findTrim error', error.message);
    }
    return [];
  };

  const getTrimSpecs = async (id: string) => {
    try {
      const { data } = await client.query({
        query: CAR_SPECS_FIND_TRIM_SPECS,
        variables: {
          filters: [
            {
              field: 'id',
              strVal: id,
            },
          ],
        },
      });
      // console.log('trim specs', data);
      return data?.carSpecsFindOne || {};
    } catch (error: any) {
      console.log('findTrimSpecs error', error.message);
    }
    return {};
  };

  return { getTrims, getTrimSpecs };
};
